export default __webpack_public_path__ + "./images/cu.cbe0e763.png";